
interface LocalisedText {
  [language: string]: string;
}

export interface Badge {
  _id: string;
  title: LocalisedText;
  description: LocalisedText;
  shape: string;
  color: string;
}
